import { BackupSystem } from '@apps/bckp/models/backup-system';
import { createAction, props } from '@ngrx/store';

export const BckpBackupSystemSelected = createAction(
    '[BCKP-SYSTEM] Bckp Backup System Selected',
    props<{ backupSystem: BackupSystem }>()
);
